export const statements = [
  {
    id: "rumor-info-leak",
    title: "关于网络流传「用户信息泄露」不实说法的澄清声明",
    categoryId: "refute",
    categoryName: "辟谣澄清",
    date: "2026-09-08",
    source: "黑料官方运营中心",
    summary:
      "近期有账号拼接后台截图，声称平台存在大规模用户信息泄露。经技术核查，相关内容为伪造截图，平台未发生所描述的数据外泄情况。",
    verdict: "网传截图系伪造，平台未发生所述信息泄露。",
    tags: ["信息泄露", "伪造截图", "数据安全"],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20of%20layered%20cream%20paper%20documents%20with%20a%20deep%20vermilion%20wax%20seal%2C%20soft%20diffused%20daylight%2C%20minimal%20architectural%20flat%20lay%2C%20no%20text%2C%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=800&seq=hl-st-01&orientation=landscape",
    sections: [
      {
        heading: "传闻内容与传播情况",
        paragraphs: [
          "自 9 月 6 日起，部分社交账号发布所谓「后台数据截图」，配文称平台因配置疏漏导致用户信息被批量导出，并附带一张来源不明的表格图片。该内容在短时间内被转发扩散。",
          "经核对，截图中出现的字段名称、界面元素与平台实际后台均不一致，图片存在明显的拼接与后期处理痕迹。",
        ],
      },
      {
        heading: "核查过程",
        paragraphs: [
          "技术团队对相关时间段内的数据访问日志、导出记录与权限变更进行了完整回溯，未发现异常的批量读取或外部导出行为。",
          "我们同时对涉及的账号进行了溯源，确认其发布内容并非来自平台内部系统。",
        ],
      },
      {
        heading: "官方结论与后续措施",
        paragraphs: [
          "平台未发生传闻所述的用户信息泄露情况，相关截图为伪造内容。请勿继续传播来源不明的截图。",
          "我们已将相关证据提交平台方进行处置，并保留对恶意造谣、伪造材料行为追究法律责任的权利。",
        ],
      },
    ],
    relatedIds: ["statement-data-privacy", "notice-verification-channel"],
  },
  {
    id: "statement-brand-impersonation",
    title: "关于冒用「黑料官方」名义发布内容的严正声明",
    categoryId: "statement",
    categoryName: "官方声明",
    date: "2026-09-02",
    source: "黑料官方法务与运营中心",
    summary:
      "发现有多家账号使用与「黑料官方」高度近似的名称与标识，擅自以官方名义发布信息并招募会员，特此声明其与本平台无任何关联。",
    verdict: "被点名账号均非官方运营，其发布内容与收费行为与平台无关。",
    tags: ["冒名账号", "品牌保护", "侵权"],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20blank%20official%20notice%20folder%20with%20red%20stamp%20mark%20on%20a%20warm%20beige%20desk%2C%20soft%20side%20light%2C%20muted%20cream%20and%20vermillion%20palette%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=hl-st-02&orientation=landscape",
    sections: [
      {
        heading: "情况说明",
        paragraphs: [
          "近期我们接到用户反馈，若干账号在使用与「黑料官方」高度近似的头像、名称与简介，并以官方名义发布未经核实的信息、拉群招募付费会员。",
          "上述账号均未获得本平台授权，其发布内容、收费行为及承诺均不代表本平台立场。",
        ],
      },
      {
        heading: "官方立场",
        paragraphs: [
          "本平台的正式信息仅通过本页面及已公示的官方渠道发布。任何以私信、群聊形式要求转账或提供账号密码的行为，均与官方无关。",
          "对于冒用名义造成用户损失的行为，我们将配合用户进行举证，并依法追究相关主体责任。",
        ],
      },
      {
        heading: "如何识别官方渠道",
        paragraphs: [
          "官方发布的公告均带有统一归档编号，并可在「声明公告库」中检索到对应原文。",
          "如遇疑似冒名账号，可通过本页「联系我们」提交材料，我们会在核实后统一公示。",
        ],
      },
    ],
    relatedIds: ["rumor-antifraud-account", "notice-verification-channel"],
  },
  {
    id: "response-content-review",
    title: "关于内容审核机制的官方回应",
    categoryId: "response",
    categoryName: "官方回应",
    date: "2026-08-26",
    source: "黑料官方内容团队",
    summary:
      "就用户关心的「内容如何被判定与处理」问题，说明审核流程、判断维度、申诉入口与处理时限。",
    verdict: "审核依据公开规则执行，用户可在结果通知页发起申诉。",
    tags: ["内容审核", "申诉机制", "规则透明"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20of%20stacked%20paper%20cards%20being%20sorted%20into%20ordered%20rows%2C%20warm%20cream%20and%20muted%20gold%20tones%2C%20soft%20diffused%20studio%20light%2C%20minimal%20flat%20lay%2C%20no%20text%2C%20clean%20neutral%20background&width=1200&height=800&seq=hl-st-03&orientation=landscape",
    sections: [
      {
        heading: "审核流程",
        paragraphs: [
          "内容进入审核后，会依次经过自动规则初筛与人工复核两个环节。涉及争议性描述的内容，会由两名以上复核人员分别判断后合并结论。",
          "每一次处理都会生成记录，包含处理时间、依据条款与操作人，用户可在结果通知中查看概要。",
        ],
      },
      {
        heading: "判断维度",
        paragraphs: [
          "我们主要从信息来源、表述是否可核实、是否涉及个人隐私、是否构成对具体主体的不当指控等维度进行判断。",
          "单纯的负面评价、批评与讨论不属于处理范围，我们只对可核查的事实性争议表述进行提示或标注。",
        ],
      },
      {
        heading: "申诉与时限",
        paragraphs: [
          "如你不同意处理结果，可在结果通知页发起申诉，注明需要复核的具体段落与理由。",
          "申诉一般在 48 小时内给出复核结论；如遇复杂情况，会同步告知预计完成时间。",
        ],
      },
    ],
    relatedIds: ["response-algorithm-hearsay", "notice-archive-upgrade"],
  },
  {
    id: "notice-verification-channel",
    title: "官方信息核实渠道更新公告",
    categoryId: "notice",
    categoryName: "公告通知",
    date: "2026-08-15",
    source: "黑料官方运营中心",
    summary:
      "为减少信息绕行，现对官方核实渠道进行统一梳理：声明只在归档页发布，核实请求统一走线索提交入口。",
    verdict: "自本公告发布起，既往的非官方联系入口停止使用。",
    tags: ["核实渠道", "服务调整", "公告"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20image%20of%20a%20single%20folded%20official%20document%20resting%20on%20a%20beige%20surface%20with%20a%20subtle%20gold%20edge%20light%2C%20soft%20shadows%2C%20cream%20palette%2C%20no%20text%2C%20high%20detail%20product%20photography%20style&width=1200&height=800&seq=hl-st-04&orientation=landscape",
    sections: [
      {
        heading: "调整内容",
        paragraphs: [
          "官方声明与辟谣内容今后统一在「声明公告库」发布，并按类别归档，方便检索与引用。",
          "信息核实请求请统一通过本页的线索提交入口发起，其他历史联系入口自本公告发布之日起停止使用。",
        ],
      },
      {
        heading: "为什么调整",
        paragraphs: [
          "此前核实请求分散在多个渠道，容易出现遗漏或重复，也增加了第三方冒名接洽的空间。",
          "集中入口后，每条请求都会生成受理编号，处理进度可查询、可追溯。",
        ],
      },
    ],
    relatedIds: ["statement-brand-impersonation", "notice-archive-upgrade"],
  },
  {
    id: "rumor-antifraud-account",
    title: "关于仿冒账号与诈骗信息的辟谣声明",
    categoryId: "refute",
    categoryName: "辟谣澄清",
    date: "2026-08-06",
    source: "黑料官方安全团队",
    summary:
      "针对以「官方客服」「内部审核」名义索要验证码、诱导转账的说法，明确此类行为均属诈骗，官方不会索要任何验证码。",
    verdict: "索要验证码、诱导转账的行为均为诈骗，与官方无关。",
    tags: ["仿冒客服", "诈骗", "验证码"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20security%20themed%20editorial%20composition%20with%20a%20padlock%20silhouette%20and%20warm%20paper%20texture%2C%20cream%20beige%20and%20vermillion%20accent%2C%20soft%20diffused%20light%2C%20minimal%20clean%20background%2C%20no%20text&width=1200&height=800&seq=hl-st-05&orientation=landscape",
    sections: [
      {
        heading: "诈骗手法说明",
        paragraphs: [
          "近期有账号冒充「黑料官方客服」，以「账号异常需验证」「内容下架需缴费」为由，诱导用户提供短信验证码或进行转账。",
          "官方在任何情况下都不会索要你的短信验证码、登录密码或支付密码，也不会要求向个人账户转账。",
        ],
      },
      {
        heading: "核实与提醒",
        paragraphs: [
          "如接到类似联系，请先通过本页线索提交入口反馈，不要点击对方提供的链接，也不要按对方指示操作。",
          "已经造成损失的，建议第一时间联系支付渠道并保留聊天记录，我们会配合提供必要的说明材料。",
        ],
      },
    ],
    relatedIds: ["statement-brand-impersonation", "notice-verification-channel"],
  },
  {
    id: "response-partnership-hearsay",
    title: "就近期「合作传闻」的官方回应",
    categoryId: "response",
    categoryName: "官方回应",
    date: "2026-07-30",
    source: "黑料官方运营中心",
    summary:
      "就网络上关于平台与某机构达成独家合作的传闻作出回应：目前处于初步沟通阶段，未签署任何具有约束力的协议。",
    verdict: "相关合作尚处沟通阶段，未达成任何正式约定。",
    tags: ["合作传闻", "口径澄清"],
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20image%20of%20two%20blank%20document%20folders%20side%20by%20side%20on%20a%20warm%20cream%20table%2C%20muted%20gold%20and%20beige%20tones%2C%20soft%20natural%20light%2C%20calm%20neutral%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=hl-st-06&orientation=landscape",
    sections: [
      {
        heading: "传闻由来",
        paragraphs: [
          "近日有内容称平台已与某机构达成独家合作，并将据此调整内容收录规则。该说法在讨论区被反复引用。",
          "实际情况是双方仅进行过初步沟通，尚未进入实质性洽谈。",
        ],
      },
      {
        heading: "官方口径",
        paragraphs: [
          "目前不存在任何已签署的独家合作安排，平台的内容规则也不会因传闻而改变。",
          "如后续有正式合作，我们会通过本页面发布公告，不会再以其他渠道先行透露。",
        ],
      },
    ],
    relatedIds: ["statement-brand-impersonation", "response-content-review"],
  },
  {
    id: "statement-data-privacy",
    title: "关于用户数据安全与隐私保护的官方声明",
    categoryId: "statement",
    categoryName: "官方声明",
    date: "2026-07-21",
    source: "黑料官方安全团队",
    summary:
      "明确平台在数据收集、存储与使用上的边界：最小必要原则、权限分级、访问留痕，并说明用户的查询与删除权利。",
    verdict: "平台遵循最小必要原则处理数据，并提供查询与删除通道。",
    tags: ["隐私保护", "数据安全", "用户权利"],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20image%20of%20a%20sealed%20cream%20envelope%20with%20a%20vermilion%20seal%2C%20soft%20warm%20lighting%2C%20beige%20background%20with%20subtle%20paper%20grain%2C%20minimal%20composition%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=hl-st-07&orientation=landscape",
    sections: [
      {
        heading: "数据处理的边界",
        paragraphs: [
          "平台仅收集实现功能所必需的信息，并按照最小必要原则控制范围、保留期限与访问权限。",
          "内部访问实行分级授权，涉及个人信息的操作全程留痕，可追溯至具体操作记录。",
        ],
      },
      {
        heading: "你的权利",
        paragraphs: [
          "你可以通过线索提交入口申请查询、更正或删除与你相关的信息，我们会在核实身份后处理。",
          "对于超出必要范围的请求，我们会说明原因并给出替代方案。",
        ],
      },
    ],
    relatedIds: ["rumor-info-leak", "response-content-review"],
  },
  {
    id: "notice-archive-upgrade",
    title: "「声明公告库」检索功能升级公告",
    categoryId: "notice",
    categoryName: "公告通知",
    date: "2026-07-10",
    source: "黑料官方产品团队",
    summary:
      "声明公告库新增分类筛选、关键词搜索与时间排序，并支持按标签定位相关公告，历史公告已全部完成归档编号。",
    verdict: "新版检索功能已上线，历史公告全部可检索。",
    tags: ["功能上线", "检索", "归档"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20studio%20image%20of%20an%20ordered%20archive%20of%20blank%20paper%20sleeves%20in%20a%20beige%20rack%2C%20soft%20diffused%20light%2C%20cream%20and%20muted%20gold%20palette%2C%20clean%20no%20text%20composition%2C%20high%20detail&width=1200&height=800&seq=hl-st-08&orientation=landscape",
    sections: [
      {
        heading: "本次升级内容",
        paragraphs: [
          "公告库支持按「官方声明 / 辟谣澄清 / 官方回应 / 公告通知」四类筛选，并可按发布时间正序或倒序排列。",
          "新增关键词搜索与标签筛选，输入事件关键词即可定位相关公告与关联条目。",
        ],
      },
      {
        heading: "归档编号说明",
        paragraphs: [
          "所有历史公告已补全归档编号，格式与发布时间对应，便于引用与比对。",
          "后续每篇公告在发布时即生成编号，可在详情页右上角查看。",
        ],
      },
    ],
    relatedIds: ["notice-verification-channel", "response-content-review"],
  },
  {
    id: "response-algorithm-hearsay",
    title: "关于信息推荐机制的官方回应",
    categoryId: "response",
    categoryName: "官方回应",
    date: "2026-06-28",
    source: "黑料官方产品团队",
    summary:
      "就有说法称平台「按关系推送、可付费置顶」，作出说明：排序依据公开的时效与相关性规则，不存在付费置顶。",
    verdict: "不存在付费置顶与关系推荐，排序规则公开可查。",
    tags: ["推荐机制", "付费置顶", "规则说明"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20timeline%20cards%20arranged%20in%20a%20gentle%20curve%20on%20a%20warm%20cream%20surface%2C%20muted%20gold%20and%20beige%20tones%2C%20soft%20light%2C%20minimal%20no%20text%20composition%2C%20high%20detail&width=1200&height=800&seq=hl-st-09&orientation=landscape",
    sections: [
      {
        heading: "排序依据",
        paragraphs: [
          "公告的展示顺序依据发布时间与事件相关度排列，越新的官方表态越靠前。",
          "分类与标签只影响筛选结果，不参与付费调节。",
        ],
      },
      {
        heading: "关于「付费置顶」说法",
        paragraphs: [
          "平台不提供付费置顶、付费优先展示等任何影响排序的服务，任何以此名义收费的行为均与官方无关。",
          "如遇此类情形，可通过线索提交入口反馈，我们会核实并统一说明。",
        ],
      },
    ],
    relatedIds: ["response-content-review", "statement-brand-impersonation"],
  },
];